import { FC } from "react";
import { IconProps } from "./types";

export const SocialFacebook: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.273 7.187c0-.67.445-.826.757-.826h1.92V3.414l-2.645-.01c-2.935 0-3.602 2.198-3.602 3.604v1.964H8.005v3.035h1.698v8.59h3.57v-8.59h2.409l.313-3.035h-2.722V7.187z"
      fill={fill}
    />
  </svg>
);
